import {useCallback, useEffect, useState} from 'react'

// The deadline keeps the display accurate after a background tab resumes.
// Enforcement remains on the server.
export function useRetryCountdown() {
  const [retryAt, setRetryAt] = useState(0)
  const [seconds, setSeconds] = useState(0)

  const start = useCallback((retryAfterSeconds?: number) => {
    if (retryAfterSeconds && retryAfterSeconds > 0) {
      const deadline = Date.now() + retryAfterSeconds * 1000
      setRetryAt((current) => Math.max(current, deadline))
      setSeconds((current) => Math.max(current, Math.ceil(retryAfterSeconds)))
    }
  }, [])

  useEffect(() => {
    const update = () => {
      const remaining = Math.max(0, Math.ceil((retryAt - Date.now()) / 1000))
      setSeconds(remaining)
      if (remaining === 0) setRetryAt(0)
    }
    update()
    if (retryAt <= Date.now()) return
    const timer = window.setInterval(update, 1000)
    return () => window.clearInterval(timer)
  }, [retryAt])

  return {seconds, start}
}
